import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetMspDetailsDto from "./dto/get-msp-details.dto";

export const MspDetailsEffectActions = {
  getMspDetails: `${Entities.MspDetails}_getMspDetails`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.MspDetails,
  initSchema,
  aliasName: DIContainerKeys.MspDetailsService,
})
export class MspDetailsService extends HttpService {
  @loader(Loaders.GetMspDetailsLoader)
  @action(DIContainerKeys.MspDetailsService)
  public *getMspDetails(dto: GetMspDetailsDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetMspDetailsLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.getMspDetails),
        params: {
          optionEnum1: dto.mspId,
        }
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetMspDetailsLoader, false);
      return;
    }
    yield this.setEntityStateById(Entities.MspDetails, dto.mspId, response);
    yield this.setLoaderState(Loaders.GetMspDetailsLoader, false);
  }
}